import React from "react";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { FaCheckCircle } from "react-icons/fa";
import { motion } from "framer-motion";
import '../styles/lines.css';

const Timeline = () => {
    return (
        <motion.div
            className="p-8 bg-gray-100 min-h-screen flex justify-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
        >
            <VerticalTimeline layout="1-column">
                {/* Step One */}
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={{ 
                        background: "#fff", 
                        color: "#333", 
                        boxShadow: "0 25px 50px -12px rgb(0 0 0 / 0.25)" 
                    }}
                    contentArrowStyle={{ borderRight: "7px solid  #fff" }}
                    iconStyle={{ background: "#96226E", color: "#fff" }}
                    icon={<FaCheckCircle />}
                    animate={{ scale: [0.8, 1] }}
                    transition={{ duration: 0.5 }}
                >
                    <h3 className="text-xl font-bold text-[#96226E] font-poppins">STEP ONE</h3>
                    <h4 className="text-2xl font-bold mt-2 font-poppins">Scope Preparation</h4>
                    <p className="mt-2 text-gray-600 font-poppins">
                        In the first step of our journey into your product, we focus on your vision. This is where we get to know your idea from head-to-toe and create a comprehensive brief for the project. It allows us to gather all the research needed, from numbers on the market to competitor benchmarks or any other information necessary. This will prevent us from being blocked by a lack of information during our immersive session together.
                    </p>
                    <p className="mt-2  text-black font-poppins">
                    Phase deliverables:
                    </p>
                    <ul className="mt-2 text-gray-700 list-disc pl-5 font-poppins">
                        <li>Comprehensive Brief</li>
                        <li>List of Research Topics</li>
                    </ul>
                </VerticalTimelineElement>

                {/* Step Two */}
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={{ 
                        background: "#fff", 
                        color: "#333", 
                        boxShadow: "0 25px 50px -12px rgb(0 0 0 / 0.25)" 
                    }}
                    contentArrowStyle={{ borderRight: "7px solid  #fff" }}
                    iconStyle={{ background: "#96226E", color: "#fff" }}
                    icon={<FaCheckCircle />}
                    animate={{ scale: [0.8, 1] }}
                    transition={{ duration: 0.5 }}
                >
                    <h3 className="text-xl font-bold text-[#96226E] font-poppins">STEP TWO</h3>
                    <h4 className="text-2xl font-bold mt-2 font-poppins">Immersive Session</h4>
                    <p className="mt-2 text-gray-600 font-poppins">
                        Bringing all the results from our research, we meet with you to craft a rock-solid value proposition and set the main assumptions to prove. Then we create the first draft of the journey your users will take through your product. These initial user stories will help evaluate the features during the next step – Product Rationale.
                    </p>
                    <p className="mt-2  text-black font-poppins">
                    Phase deliverables:
                    </p>
                    <ul className="mt-2 text-gray-700 list-disc pl-5 font-poppins">
                        <li>Revised Value Proposition</li>
                        <li>Initial User Stories</li>
                        <li>List of Main Assumptions to Prove</li>
                    </ul>
                </VerticalTimelineElement>

                {/* Step Three */}
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={{ 
                        background: "#fff", 
                        color: "#333", 
                        boxShadow: "0 25px 50px -12px rgb(0 0 0 / 0.25)" 
                    }}
                    contentArrowStyle={{ borderRight: "7px solid  #fff" }}
                    iconStyle={{ background: "#96226E", color: "#fff" }}
                    icon={<FaCheckCircle />}
                    animate={{ scale: [0.8, 1] }}
                    transition={{ duration: 0.5 }}
                >
                    <h3 className="text-xl font-bold text-[#96226E] font-poppins">STEP THREE</h3>
                    <h4 className="text-2xl font-bold mt-2 font-poppins">Product Rationale</h4>
                    <p className="mt-2 text-gray-600 font-poppins">
                        At this point, we’ll have all the information we need to create the ultimate list of User Stories and features necessary to prove the main assumptions in a Minimum Viable Product (MVP) or Proof of Concept (POC). Our experts in Product, UX/UI and Tech Architecture will focus on finding the answers to all of the questions raised throughout our journey together.
                    </p>
                    <p className="mt-2  text-black font-poppins">
                    Phase deliverables:
                    </p>
                    <ul className="mt-2 text-gray-700 list-disc pl-5 font-poppins">
                        <li>Complete User Stories</li>
                        <li>Tech Scope</li>
                        <li>Business Model</li>
                        <li>Key BPMN (Business Process Model & Notation)</li>
                        <li>Tech Spike</li>
                    </ul>
                </VerticalTimelineElement>
            </VerticalTimeline>
        </motion.div>
    );
};

export default Timeline;